// TODO: VL-6033 - re-write the vl_chat FE by FE engineers
import React from 'react';
import { UserMessageProps } from '@copilotkit/react-ui';
import { getInitials, getAvatarColor } from './utils';
import styles from './CustomUserMessage.module.scss';

interface CustomUserMessageComponentProps extends UserMessageProps {
  userName?: string;
  userEmail?: string;
}

/**
 * Custom user message component with user initials avatar
 * Based on default UserMessage from CopilotKit
 */
const CustomUserMessage: React.FC<CustomUserMessageComponentProps> = (props) => {
  const { message, ImageRenderer, userName, userEmail } = props;
  const isImageMessage = message && "image" in message && message.image;
  
  // Get user display name from props or context
  const displayName = userName || userEmail?.split('@')[0] || 'User';
  const initials = getInitials(displayName);
  const avatarColor = getAvatarColor(displayName);
  
  // Image message
  if (isImageMessage) {
    const imageMessage = message;
    
    return (
      <div className={styles.wrapper}>
        <div className="copilotKitMessage copilotKitUserMessage">
          <ImageRenderer image={imageMessage.image!} content={imageMessage.content} />
        </div>
        <div 
          className={styles.avatar}
          style={{ backgroundColor: avatarColor }}
          title={displayName}
        >
          {initials}
        </div>
      </div>
    );
  }
  
  // Regular text message
  return (
    <div className={styles.wrapper}>
      <div className="copilotKitMessage copilotKitUserMessage">
        {message?.content}
      </div>
      <div 
        className={styles.avatar}
        style={{ backgroundColor: avatarColor }}
        title={displayName}
      >
        {initials}
      </div>
    </div>
  );
};

export default CustomUserMessage;